import { apiClient } from "../common/axiosInstance";
import { handleAxiosError } from "../common/handleAxiosError";
import { IFormData } from "./types";

export const createCompany = async (formData: IFormData) => {
  try {
    const response = await apiClient.post("/company/create", formData)
    return response.data;
  } catch (error) {
    handleAxiosError(error, "Error al crear la compañía");
  }
};
